import * as React from "react";
import styled from "styled-components";

export const Hub_InteractiveTable: React.FC<Record<string, never>> = () => {
  return (
    <div className="accordion" id="accordionTable">
      <div className="row">
        <div className="col-12 col-md-4" style={{ paddingLeft: 0 }}>
          <div className="card bg-transparent border-0 mb-0">
            <AccordionHeader
              className="card-header bg-success heading-one"
              id="headingOne"
            >
              <h2 className="h3 mb-0">
                <AccordionButton
                  className="btn btn-link btn-block"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Within a few months
                </AccordionButton>
              </h2>
            </AccordionHeader>
            <div
              id="collapseOne"
              className="collapse multi-collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionTable"
            >
              <AccordionBody className="card-body">
                <ul className="bullet-fulcrum bullet-gold">
                  <li>Worker morale and engagement</li>
                  <li>Team cohesion</li>
                </ul>
              </AccordionBody>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4" style={{ paddingLeft: 0 }}>
          <div className="card bg-transparent border-0 mb-0">
            <AccordionHeader
              className="card-header bg-lime heading-two"
              id="headingTwo"
            >
              <h2 className="h3 mb-0">
                <AccordionButton
                  className="btn btn-link btn-block collapsed"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Within 1-2 years
                </AccordionButton>
              </h2>
            </AccordionHeader>
            <div
              id="collapseTwo"
              className="collapse multi-collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionTable"
            >
              <AccordionBody className="card-body">
                <ul className="bullet-fulcrum bullet-gold">
                  <li>Individual work performance and productivity</li>
                  <li>Attraction and retention of employees</li>
                  <li>Improvement corporate and recruitment image</li>
                  <li>Individual health knowledge</li>
                  <li>Job satisfaction</li>
                </ul>
              </AccordionBody>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4" style={{ paddingLeft: 0 }}>
          <div className="card bg-transparent border-0 mb-0">
            <AccordionHeader
              className="card-header bg-primary heading-three"
              id="headingThree"
            >
              <h2 className="h3 mb-0">
                <AccordionButton
                  className="btn btn-link btn-block collapsed"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Within 3-5 years
                </AccordionButton>
              </h2>
            </AccordionHeader>
            <div
              id="collapseThree"
              className="collapse multi-collapse"
              aria-labelledby="headingThree"
              data-parent="#accordionTable"
            >
              <AccordionBody className="card-body">
                <ul className="bullet-fulcrum bullet-gold">
                  <li>Workplace injuries and associated expenses</li>
                  <li>Absenteeism and sick leave</li>
                  <li>Incidence of attending work when sick</li>
                  <li>Improved relations among workers and with management</li>
                  <li>Return on training and development investment</li>
                </ul>
              </AccordionBody>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AccordionHeader = styled.div`
  width: calc(100% + 1rem);
  clip-path: polygon(
    0 0,
    calc(100% - 1rem) 0,
    100% 50%,
    calc(100% - 1rem) 100%,
    0 100%
  );

  @media screen and (min-width: 768px) {
    &.heading-two,
    &.heading-three {
      clip-path: polygon(
        0 0,
        calc(100% - 1rem) 0,
        100% 50%,
        calc(100% - 1rem) 100%,
        0 100%,
        1rem 50%
      );
    }
  }
`;

const AccordionButton = styled.button`
  padding: 0.5rem;
  text-align: left;
  text-transform: uppercase;
  color: white;
  font-weight: bold;

  &:focus,
  &:hover {
    color: white;
    outline: none;
    box-shadow: none;
  }
`;

const AccordionBody = styled.div`
  padding: 1rem 0.5rem 0.5rem;
  border: 1px solid #888;
  border-top: none;
  background-color: floralwhite;
`;
